module.exports = __webpack_public_path__ + "static/img/cj16.14804c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj16.png
// module id = 158
// module chunks = 0